import { render, staticRenderFns } from "./ThemeOrigin.vue?vue&type=template&id=607eef5f&scoped=true"
import script from "./ThemeOrigin.vue?vue&type=script&lang=js"
export * from "./ThemeOrigin.vue?vue&type=script&lang=js"
import style0 from "./ThemeOrigin.vue?vue&type=style&index=0&id=607eef5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607eef5f",
  null
  
)

export default component.exports